const practices = [
  { icon: 'ri-team-line', title: 'Ролевые переговоры', desc: 'Участники проводят переговоры в ролях руководителя и другой стороны, отрабатывая реальные сценарии.' },
  { icon: 'ri-file-list-3-line', title: 'Управленческие кейсы', desc: 'Разбор типовых ситуаций: защита бюджета, сложный сотрудник, переговоры с собственником.' },
  { icon: 'ri-user-voice-line', title: 'Реальные ситуации участников', desc: 'Работа с переговорами, которые действительно происходят у руководителей в компании.' },
  { icon: 'ri-sword-line', title: 'Переговорные дуэли', desc: 'Интенсивная отработка конкретных ситуаций один на один с разбором результата.' },
  { icon: 'ri-map-2-line', title: 'Разбор переговорных стратегий', desc: 'Анализ того, какие стратегии работают, а какие приводят к потере позиции.' },
  { icon: 'ri-scales-2-line', title: 'Отработка аргументации', desc: 'Тренировка построения аргументов на основе фактов, целей бизнеса и интересов сторон.' },
  { icon: 'ri-flashlight-line', title: 'Работа с давлением', desc: 'Упражнения на сохранение контроля в условиях давления, манипуляций и эмоциональных реакций.' },
  { icon: 'ri-swap-line', title: 'Тренировка уступок', desc: 'Отработка того, когда уступать, что просить взамен и как не превращать переговоры в одностороннее движение.' },
  { icon: 'ri-file-check-line', title: 'Фиксация договорённостей', desc: 'Перевод разговора в конкретные обязательства, сроки и критерии результата.' },
];

export default function HowPracticeGoes() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Практика на реальных ситуациях
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Обучение строится вокруг практики, а не вокруг лекций о переговорах
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {practices.map((p) => (
            <div key={p.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${p.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{p.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed">
            Не просто разбираем модели переговоров — руководители тренируются применять их в ситуациях, которые действительно возникают в их работе.
          </p>
        </div>
      </div>
    </section>
  );
}